﻿import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DataService } from './data.service';

import { HttpParams } from '@angular/common/http';

@Injectable()
export class LoggingService {
    url: string;
    constructor(private _dataService: DataService) { }

    /**
     * @param {string} url Ruta que fue llamada al momento de generar el error.
     * @param {string} message Contenido del mensaje (personalizado).
     * @param {function} stack Contenido del trace realizado al momento de generar el error.
     **/
    public error(url: string, message: string, stack: string) {
        let messageError: string = '';

        messageError += 'Type: ' + 'Error' + '\r\n';
        messageError += 'Url: ' + url + '\r\n';
        messageError += 'Message: ' + message + '\r\n';
        messageError += 'Stack: ' + stack + '\r\n';

        this.sendWriteMessage(messageError);
    }

     /**
     * @param {number} code Ruta que fue llamada al momento de generar el warning.
     * @param {string} url Ruta que fue llamada al momento de generar el warning.
     * @param {string} message Contenido del mensaje (personalizado).
     **/
    public warning(code: number, url: string, message: string) {
        let messageWarning: string = '';

        messageWarning += 'Type: ' + 'Warning' + '\r\n';
        messageWarning += 'Code: ' + code + '\r\n';
        messageWarning += 'Url: ' + url + '\r\n';
        messageWarning += 'Message: ' + message + '\r\n';

        this.sendWriteMessage(messageWarning);
    }

    /**
     * @param {string} url Ruta que fue llamada al momento de generar la info.
     * @param {string} message Contenido del mensaje (personalizado).
     **/
    public information(url: string, message: string) {
        let messageInformation: string = '';

        messageInformation += 'Type: ' + 'Information' + '\r\n';
        messageInformation += 'Url: ' + url + '\r\n';
        messageInformation += 'Message: ' + message + '\r\n';

        this.sendWriteMessage(messageInformation);
    }

    /**
     * @param {string} url Ruta que fue llamada al momento de generar el debug.
     * @param {string} message Contenido del mensaje (personalizado).
     * @param {function} stack Contenido del trace realizado al momento de generar el debugger.
     **/
    public debug(url: string, message: string, stack: string) {
        let messageDebug: string = '';

        messageDebug += 'Type: ' + 'Error' + '\r\n';
        messageDebug += 'Url: ' + url + '\r\n';
        messageDebug += 'Message: ' + message + '\r\n';
        messageDebug += 'Stack: ' + stack + '\r\n';

        this.sendWriteMessage(messageDebug);
    }

    /**
     * @param {string} message Contenido del mensaje (personalizado).
     **/
    public log(message: string) {
        let messageLog: string = '';

        messageLog += 'Type: ' + 'Information' + '\r\n';
        messageLog += 'Message: ' + message + '\r\n';

        this.sendWriteMessage(messageLog);
    }

    /**
     * @param {string} message Contenido del mensaje (personalizado).
     **/
    private sendWriteMessage(message: string) {
        this.url = 'http://localhost:8000/logging';
        let parameters = new HttpParams();
        parameters = parameters.append('message', message);

        //this._dataService.execPostUrlencoded(this.url, parameters);
    }
}
